<template>
  <div>
    <v-dialog
      v-model="value"
      persistent
      max-width="650px"
      style="max-height=94%"
      scrollable
    >
      <div v-if="collaborator === undefined"></div>
      <div v-else-if="error.show === true" style="width: 100%">
        <v-card>
          <v-card-text>
            <v-card-title class="headline _error_title">
              Ocurrió un error
              <v-icon color="orange">warning</v-icon>
            </v-card-title>
            <div class="_error_box">
              <p>
                {{ error.message }}
              </p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="close"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </div>
      <v-card v-else :style="loading ? 'pointer-events: none;' : ''">
        <div class="_loading" v-show="loading">
          <v-progress-circular :size="50" color="primary" indeterminate />
          Cargando...
        </div>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Editar Datos</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex order-xs2 order-md2 xs8 md8>
                <v-layout wrap>
                  <v-flex>
                    <v-text-field
                      v-model="collaborator.firstName"
                      :error-messages="nameErrors"
                      label="Nombre(s)"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      v-model="collaborator.lastName"
                      :error-messages="lastNameErrors"
                      label="Apellidos"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      :error-messages="emailErrors"
                      v-model="tempEmail"
                      label="Correo electrónico"
                      @keyup="watchEmail"
                    />
                  </v-flex>
                  <v-flex>
                    <v-select
                      v-model="collaborator.webRole"
                      close-on-complete
                      item-text="name"
                      :item-value="(e) => e"
                      :items="roles"
                      label="Roles"
                      hide-details
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="close"> Cancelar </v-btn>
          <v-btn
            color="primary darken-1"
            flat
            @click="submit"
            :disabled="isValidSubmitBtn()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value', 'roles', 'collaborator'],
  components: {},
  watch: {
    collaborator: function () {
      this._initState()
      if (this.collaborator.updatedEmail !== '') {
        this.tempEmail = this.collaborator.updatedEmail
        this.isNewEmail = true
      } else {
        this.tempEmail = this.collaborator.email
        this.isNewEmail = false
      }
    },
  },

  mounted() {},
  data: () => ({
    tempEmail: '',
    isNewEmail: false,
    isDifferentEmail: false,
    loading: false,
    error: { show: false, message: '' },
    inputErrors: {
      firstName: '',
      lastName: '',
      email: '',
    },
  }),
  methods: {
    _initState() {
      this.tempEmail = ''
      this.isNewEmail = false
      this.isDifferentEmail = false
      this.loading = false
      this.error = { show: false, message: '' }
      this.inputErrors = {
        firstName: '',
        lastName: '',
        email: '',
      }
    },
    watchEmail() {
      if (this.isNewEmail === true) return

      if (
        this.tempEmail !== this.collaborator.email &&
        this.collaborator.status !== 'NEW'
      ) {
        this.isDifferentEmail = true
      } else {
        this.isDifferentEmail = false
      }
    },
    _isInvalidFirstName() {
      const invalid = this.collaborator.firstName.trim() === ''

      if (invalid) {
        this.inputErrors.firstName = 'Campo inválido'
        return true
      } else {
        this.inputErrors.firstName = ''
        return false
      }
    },
    _isInvalidLastName() {
      const invalid = this.collaborator.lastName.trim() === ''

      if (invalid) {
        this.inputErrors.lastName = 'Campo inválido'
        return true
      } else {
        this.inputErrors.lastName = ''
        return false
      }
    },
    _isInvalidEmail() {
      const regexEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)
      const isTempEmailInvalid = regexEmail.test(this.tempEmail) === false

      if (isTempEmailInvalid) {
        this.inputErrors.email = 'Corrro inválido'
        return true
      } else {
        this.inputErrors.email = ''
        return false
      }
    },
    isValidSubmitBtn() {
      const isNameEmpty = this._isInvalidFirstName()
      const isLastNameEmpty = this._isInvalidLastName()
      const isTempEmailInvalid = this._isInvalidEmail()

      return [isNameEmpty, isLastNameEmpty, isTempEmailInvalid].some(
        (e) => e === true
      )
    },
    async _updateItem() {
      this.loading = true
      try {
        const response = await this.$store.dispatch(
          'employee/massiveUploadUpdateItem',
          [this.collaborator.id, this.collaborator]
        )

        return response.data
      } catch (error) {
        console.log(error)
        if (error.response.status === 400) {
          this.error.message = 'Error 400: correo nuevo repetido'
        }
        this.error.show = true
        return undefined
      } finally {
        this.loading = false
      }
    },
    async submit() {
      if (this.isNewEmail === true || this.isDifferentEmail === true) {
        this.collaborator.updatedEmail = this.tempEmail
      } else {
        this.collaborator.email = this.tempEmail
      }

      const editedCollab = await this._updateItem()

      if (editedCollab === undefined) {
        this.close()
        this.$emit('updatedCollab', undefined)
        return
      }
      this.$emit('updatedCollab', editedCollab)
      this.close()
    },
    close() {
      this.value = false
      this.$emit('updatedCollab', undefined)
      this.$emit('input', false)
    },
  },
}
</script>

<style scoped>
._error_title {
  display: flex;
  justify-content: center;
}
._error_box {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
}
._error_box p {
  margin: 0;
}

._loading {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #bdbdbd85;
  pointer-events: none;
  z-index: 1;
  font-size: 17px;
  font-weight: 500;
}
</style>
